import { notifications } from '@mantine/notifications';
import { AxiosError } from 'axios';

import { queryClient } from '@/libraries/react-query';
import storage from '@/utils/storage';

export function endSession() {
  storage.clearToken();
  // Drops pending loading toasts; the later notifications.update on a removed id is a no-op.
  notifications.clean();
  queryClient.resetQueries();
}

/**
 * DEV-3670: mid-session 401 ends the session, same as a page reload with an invalid token.
 * ROLE_RESTRICTED is a role mismatch, not an auth failure: the server says clients must not log out.
 */
export function endSessionOnUnauthorized(error: AxiosError<{ code?: string }>) {
  if (error.response?.status !== 401 || error.response.data?.code === 'ROLE_RESTRICTED') {
    return;
  }
  const token = storage.getToken();
  if (token) {
    // Stale 401 from a previous session must not end the current one.
    if (error.config?.headers?.get('Authorization') !== `Bearer ${token}`) {
      return;
    }
  } else if (!queryClient.getQueryData(['account-me'])) {
    // Nothing to end (sign-in screen): don't loop. Otherwise another tab cleared the token.
    return;
  }
  endSession();
}
